import { render, staticRenderFns } from "./Podesuvanja.vue?vue&type=template&id=eb50d460&scoped=true"
import script from "./Podesuvanja.vue?vue&type=script&lang=js"
export * from "./Podesuvanja.vue?vue&type=script&lang=js"
import style0 from "./Podesuvanja.vue?vue&type=style&index=0&id=eb50d460&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb50d460",
  null
  
)

export default component.exports